<template>
    <div></div>
</template>

<script>
    // variables

    export default {
        props: {
            audioStartPosition: {
                type: Number,
                default: 0,
            },
            play: {
                type: Boolean,
                default: false,
                required: true,
            },
            loop: {
                type: Boolean,
                default: true,
                required: true,
            },
            loopStart: {
                type: Number,
                default: 0,
            },
            loopEnd: {
                type: Number,
                default: 0,
            },
            fadeIn: {
                type: Boolean,
                default: false,
            },
            fadeOut: {
                type: Boolean,
                default: false,
            },
            fadeMilliseconds: {
                type: Number,
                default: 1000,
            },
            sourceFile: {
                type: String,
                required: true,
            },
            volume: {
                type: Number,
                default: 0.8,
                required: false
            }
        },
        watch: {
            play(play) {

                if (play) {
                    if (this.fadeIn) {
                        clearInterval(this.fadeInterval);
                        this.audio.volume = 0;
                        this.fadeInterval = setInterval(() => {
                            this.audio.volume += 0.1;
                            if (this.audio.volume >= 0.9) {
                                clearInterval(this.fadeInterval);
                            }
                        }, this.fadeIntervalDuration);
                    }
                    this.audio.play();
                } else {
                    if (this.fadeOut) {
                        clearInterval(this.fadeInterval);
                        this.fadeInterval = setInterval(() => {
                            this.audio.volume -= 0.1;
                            if (this.audio.volume < 0.1) {
                                clearInterval(this.fadeInterval);
                                this.audio.pause();
                            }
                        }, this.fadeIntervalDuration);
                    } else {
                        this.audio.pause();
                    }
                }
            }
        },
        mounted() {
            this.audio = new Audio(this.sourceFile);
            this.audio.loop = this.loop;
            this.audio.volume = this.volume;

            this.audio.addEventListener('timeupdate', this.timeUpdateEvent);
            if (this.play) {
                this.audio.currentTime = this.startPosition;
                this.audio.play();
            }
        },
        methods: {
            timeUpdateEvent() {
                const currentPosition = this.audio.currentTime;
                this.currentPosition = currentPosition;
                if (this.loop && this.loopEnd !== 0 && currentPosition > this.loopEnd) {
                    console.log(currentPosition);
                    this.audio.currentTime = this.startPosition;
                }
            }
        },
        beforeDestroy() {
            this.audio.pause();
            delete this.audio;
            this.audio = null;
            this.audio.removeEventListener('timeupdate', this.timeUpdateEvent);
        },
        data() {
            return {
                fadeInterval: 0,
                audio: null,
                currentPosition: 0,
            }
        },
        computed: {
            fadeIntervalDuration() {
                const maxVolume = 0.9;
                const minVolume = 0.001;
                const step = 0.1;
                return (this.fadeMilliseconds / ((maxVolume - minVolume) / step));
            },
            startPosition() {
                return (this.loop && this.loopStart) ? this.loopStart : 0;
            }
        }
    }
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/AudioElement.vue